export const PROCESS = [
  ["Discover", "Understand the customer, problem, business objectives, constraints, and success criteria."],
  ["Define", "Create product requirements, prioritize features, validate assumptions, and choose an appropriate technical approach."],
  ["Design", "Develop user flows, interface systems, prototypes, and the product experience."],
  ["Build", "Implement the product iteratively, test critical workflows, and validate progress against agreed outcomes."],
  ["Launch & evolve", "Deploy, measure, improve, and plan the next stage of development."],
];

export const CAPABILITIES = [
  ["Product strategy & discovery", "/services/product-discovery"],
  ["UX/UI design & prototyping", "/services/product-discovery"],
  ["MVP & SaaS development", "/services/mvp-development"],
  ["AI applications & agents", "/services/ai-engineering"],
  ["API integrations & automation", "/services/architecture-cloud"],
  ["Cloud architecture & deployment", "/services/architecture-cloud"],
  ["Fractional CTO & leadership", "/services/fractional-cto"],
  ["Modernization & performance", "/services/product-rescue"],
];

export const WHY = [
  ["Product thinking first", "We consider the user, the problem, the business model, and the path to market before optimizing implementation details."],
  ["Senior technical ownership", "We bring architecture, engineering, and product decisions together rather than treating development as isolated coding tasks."],
  ["AI where it makes sense", "We use AI to create meaningful product capabilities and improve workflows, without adding AI merely for marketing."],
  ["Built to evolve", "We prioritize maintainable architecture, sensible technical choices, and systems that can grow as the business evolves."],
];

export const PARTNERSHIP_TYPES = [
  "Technical co-building", "Product validation and prototyping", "Engineering partnerships",
  "Selective cash-plus-equity arrangements", "Long-term venture collaborations",
];

export const BUILD_STAGES = [
  ["Discovery & alignment", "Agree on the problem, users, goals, and constraints.", ["Problem statement", "Success criteria", "Stakeholder map"]],
  ["Product specification", "Turn goals into prioritized, testable requirements.", ["PRD", "Prioritized feature list", "Acceptance criteria"]],
  ["UX/UI design", "Design the flows and interface people will actually use.", ["User flows", "Design system", "Clickable prototype"]],
  ["Architecture & technical planning", "Choose the stack and structure that fit your stage.", ["Architecture overview", "Data model", "Delivery plan"]],
  ["Iterative development", "Build in short cycles with working software at every step.", ["Regular demos", "Staging environment", "Progress updates"]],
  ["Testing & review", "Verify critical workflows before they reach users.", ["Test coverage of key flows", "Review notes", "Release checklist"]],
  ["Deployment & handover", "Launch to production and make sure your team can run it.", ["Production deployment", "Documentation", "Access handover"]],
  ["Ongoing optimization", "Measure what's happening and improve what matters.", ["Monitoring", "Improvement backlog", "Next-stage plan"]],
];

export const WORKING_TERMS = [
  ["Communication", "A fixed rhythm of check-ins and demos, a shared channel for day-to-day questions, and written summaries of decisions."],
  ["Approvals", "Each milestone has acceptance criteria. You review working software, not just status reports."],
  ["Scope changes", "Change is normal. New requests are estimated and prioritized openly, so trade-offs are visible before work begins."],
  ["Ownership", "Ownership of code, designs, and accounts is defined in the agreement. Third-party accounts are set up in your name wherever possible."],
  ["Delivery expectations", "We commit to what we can deliver, flag risks early, and never report progress we haven't verified."],
];

export const ENGAGEMENT_MODELS = [
  ["Discovery engagement", "A defined initial engagement for research, requirements, and technical planning — ideal before committing to a full build.", ["Problem & user research", "PRD and scope", "Technical approach", "Estimate for the build"]],
  ["Project-based", "A defined scope with milestones, deliverables, and acceptance criteria.", ["Agreed scope & milestones", "Acceptance criteria", "Change process"]],
  ["Monthly engineering partnership", "Ongoing product development and technical support from a consistent team.", ["Continuous delivery", "Prioritized backlog", "Monthly planning"]],
  ["Fractional CTO", "An agreed level of technical leadership and advisory support.", ["Strategy & architecture", "Team & vendor guidance", "Defined availability"]],
  ["Venture partnership", "A selective arrangement with separately negotiated contributions, ownership, responsibilities, and governance.", ["Evaluated case by case", "Negotiated terms", "Long-term alignment"]],
];

export const PRICING_FACTORS = [
  "Scope and number of core workflows", "Design depth and brand requirements", "Integrations and AI components",
  "Security, compliance, and data requirements", "Timeline and team size", "Level of ongoing support",
];

export const INSIGHT_TOPICS = [
  ["Startup product development", "How to build an MVP without overengineering it"],
  ["Working with partners", "What founders should prepare before hiring a development partner"],
  ["Technical leadership", "When a startup needs a fractional CTO"],
  ["AI engineering", "How to evaluate an AI feature before adding it to a SaaS product"],
  ["SaaS architecture", "How to plan a SaaS architecture for an early-stage startup"],
  ["Product modernization", "How to modernize a product without rewriting everything"],
];
